/**
 * Serviceplan MAKEOS
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface UpdateCollectionDto { 
    name?: string;
    description?: string;
    assets?: Array<string>;
    /**
     * MongoDB ObjectId of the cover asset
     */
    coverAssetID?: string;
    ownerIDs?: Array<string>;
    keywords?: Array<string>;
    customFields?: object;
    published?: Array<string>;
}

